import { addMinutes, isWithinInterval, subMinutes } from "date-fns";

const marginInMinutes = 10;

export default function JoinLiveButton({
  children,
  duration,
  startDate,
}: {
  children: React.ReactNode;
  duration: number;
  startDate: string;
}) {
  // if we are start - 10 and start + duration show button, otherwise show nothing
  const shouldSeen = isWithinInterval(new Date(), {
    start: subMinutes(new Date(startDate), marginInMinutes),
    end: addMinutes(new Date(startDate), duration),
  })
  return shouldSeen ? children : null;
}
